import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ocr-plus-txt-tbl',
  templateUrl: './ocr-plus-txt-tbl.component.html',
  styleUrls: ['./ocr-plus-txt-tbl.component.css']
})
export class OcrPlusTxtTblComponent {
  @Input() item: any;
  tblData:any = {"headers": [], data: ["tst"]};

  ngAfterViewInit() {
    this.tblData = this.processMarkdownTable(this.item.text)
  }

  getTblHeaders() {
    return this.tblData.headers
  }
  getTbData() {
    return this.tblData.data
  }

  processMarkdownTable(markdownTableText) {
    // 1. Split the table text by newlines and remove empty lines
    const lines = markdownTableText.split("\n").filter(line => line.trim() !== "");
  
    // 2. Extract headers (first line)
    let headers = lines[0].split("|").map(cell => cell.trim()).slice(1, -1);
    headers
  
    // 3. Extract data rows (remaining lines after skipping header and potential empty line)
    const data = lines.slice(2).map(row => {
      let cells = row.split("|").map(cell => cell.trim()).slice(1, -1);
      return cells;
    });
  
    // 4. Return the processed table data
    return {
      headers,
      data,
    };
  }
}
